// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"userStats_cardContainer__357PL","dashBoard":"userStats_dashBoard__1dWs2","dashScore":"userStats_dashScore__5GpBD","divider":"userStats_divider__1HNvM"};